/**
 * Slot Check Search access refresh: keeps userInfo.slotCheckSearchEnabled in
 * sync with Mongo users.slotCheckSearchEnabled without a logout / re-login.
 *
 * Login (full user doc) and GetMe (when ms-auth projects the field) set it too;
 * this covers sessions that started before the flag was set, and an ms-auth
 * that does not return it from GetMe yet. A failed / missing endpoint never
 * changes the current value.
 */
export const SLOT_CHECK_SEARCH_ACCESS_MIN_INTERVAL_MS = 60 * 1000;

export type AccessResponse = { status?: string; enabled?: unknown; value?: unknown } | null | undefined | void;

/** The value to store, or undefined when the response should be ignored. */
export function accessValueFromResponse(resp: AccessResponse): number | string | null | undefined {
  if (!resp || resp.status !== 'ok') return undefined;
  if (resp.value === null || typeof resp.value === 'number' || typeof resp.value === 'string') {
    return resp.value;
  }
  if (typeof resp.enabled === 'boolean') return resp.enabled ? 1 : 0;
  return undefined;
}

/** Throttle: refresh at most once per interval unless forced (login / auth change). */
export function shouldRefreshAccess(lastAt: number | null, now: number, force = false): boolean {
  if (force || lastAt === null) return true;
  return now - lastAt >= SLOT_CHECK_SEARCH_ACCESS_MIN_INTERVAL_MS;
}
